import { combineReducers } from "redux";
import { withResetState } from "../../../wrapperReducer";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer, { initPerformersState, } from "../common/params";
import outUnderPerformers from "./outUnderPerformers";
export default combineReducers({
    reducersData: outUnderPerformers,
    commonData: commonReducer,
    paramsData: withResetState(initPerformersState)(drivingMarketParamsReducer),
});
